const GiftCardSkeleton = () => {
  return (
    <div className="font-inter rounded-xs bg-background-default relative overflow-hidden p-3 shadow-sm">
      <div className="flex flex-col items-center justify-center gap-3">
        <div className="bg-background-subtle flex aspect-square w-full animate-pulse items-center justify-center overflow-hidden rounded-sm">
          <svg className="text-icon-subtle h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentcolor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <div className="flex w-full flex-col items-start gap-2">
          <div className="bg-background-subtle h-5 w-2/3 animate-pulse rounded-sm md:h-6" />
          <div className="flex w-full flex-col items-start gap-1">
            <div className="bg-background-subtle h-3 w-1/3 animate-pulse rounded-sm" />
            <div className="bg-background-subtle h-4 w-1/2 animate-pulse rounded-sm md:h-5" />
          </div>
        </div>
        <div className="rounded-xs bg-background-hover absolute right-4 top-4 h-8 w-20 animate-pulse" />
      </div>
    </div>
  );
};

export default GiftCardSkeleton;
